import UserKYC from './UserKYC';

export default UserKYC;
